import { render, staticRenderFns } from "./BrHeader.vue?vue&type=template&id=bb9c90f6&scoped=true"
import script from "./BrHeader.vue?vue&type=script&lang=js"
export * from "./BrHeader.vue?vue&type=script&lang=js"
import style0 from "./BrHeader.vue?vue&type=style&index=0&id=bb9c90f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9c90f6",
  null
  
)

export default component.exports